import React from "react";

export interface ToastIconShellProps {
  icon: React.ReactNode;
  children: React.ReactNode;
}

/**
 * Shared toast layout: a fixed-size leading icon and a content column.
 * Icon identifies the toast's *type*; the Toast variant carries urgency.
 */
export const ToastIconShell = ({ icon, children }: ToastIconShellProps) => (
  <div className={"flex items-start space-x-3"}>
    <div className={"mt-0.5 flex-shrink-0"}>{icon}</div>
    <div className={"grid flex-1 gap-1"}>{children}</div>
  </div>
);
